import { CSSProperties, PropsWithChildren } from "react";
import Icon, { IconProps } from "../Icon/Icon";
import Tooltip from "../Tooltip/Tooltip";
import { cn } from "@/shared/utils/cn";

export interface QuestionProps extends PropsWithChildren, Partial<IconProps> {
  right?: string;
  top?: string;
  tooltipHtml?: string;
  tooltipContent?: string;
  containerClassName?: string;
}

const Question = ({
  children,
  right = "-1rem",
  top = "-1rem",
  className = "",
  containerClassName = "block",
  tooltipHtml: html = undefined,
  tooltipContent: content = undefined,
}: QuestionProps) => {
  const iconPositionStyle = {
    "--question-right": right,
    "--question-top": top,
  } as CSSProperties;

  return (
    <div className={cn("relative",containerClassName)}>
      <>
        {children}
        <Tooltip
          content={
            html ? <div dangerouslySetInnerHTML={{ __html: html }} /> : content
          }
        >
          <div>
            <div
              className="absolute right-[var(--question-right)] top-[var(--question-top)] cursor-pointer"
              style={iconPositionStyle}
            >
              <Icon
                className={`h-8 w-8 fill-primary text-primary ${className}`.trim()}
                variants="question"
              />
            </div>
          </div>
        </Tooltip>
      </>
    </div>
  );
};

export default Question;
